import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "checklist/type-model"

class service {

    selectList(params) {
        return http.list(path + "/selectList",params);
    }

    getModelsByEnterpriseId(enterpriseId){
        let params = new URLSearchParams()
        params.set("status", "1")
        params.set("enterpriseId", enterpriseId)
        return http.list(path + "/selectList",params);
    }

    getAllTypeChecklistModel() {
        let params = new URLSearchParams()
        params.set("status", "1")
        return http.list(path + "/selectAll",params);
    }

    getResume(type, param, allStatus = false) {

        return http.getResume(path,type,param,allStatus);

    }

}

export default new service();

